import {connect} from 'react-redux';

import {
  createSelector,
  makeMapDispatchToProps,
  makeMapStateToProps,
} from '../../../../srcCommon/helpers/reselectHelpers';
import {isTeamNamespace} from '../../../helpers/models/namespaceHelpers';
import {CardNoteModel} from '../../../models/api/cardNoteModel';
import {AppState} from '../../../store/appState';
import {
  deleteCardNoteAsyncAction,
  updateCardNoteAsyncAction,
} from '../../../store/data/cardNotes/cardNotesActions';
import {getFindTeammate} from '../../../store/data/teammates/lazyTeammatesSelectors';
import {getFlatTeams} from '../../../store/data/teams/teamsSelectors';
import {ContactDetailsPanelId} from '../../../store/panels/panelStateBase';
import {ContactNote} from './contactNote';

/*
 * Props.
 */

interface ContactNoteContainerProps {
  note: CardNoteModel;
  panelId: ContactDetailsPanelId;
}

/*
 * Selectors.
 */

function getNoteNamespace(_state: AppState, props: ContactNoteContainerProps) {
  return props.note.namespace;
}

function getAuthorId(_state: AppState, props: ContactNoteContainerProps) {
  return props.note.authorId;
}

function makeGetTeam() {
  return createSelector([getFlatTeams, getNoteNamespace], (teams, namespace) => {
    if (isTeamNamespace(namespace)) {
      return teams.find((team) => team.namespace === namespace);
    }
    return undefined;
  });
}

function makeGetTeammate() {
  return createSelector([getFindTeammate, getAuthorId], (findTeammate, authorId) =>
    findTeammate(authorId, 'ContactNoteContainer makeGetTeammate'),
  );
}

/*
 * Redux.
 */

const mapStateToProps = makeMapStateToProps<ContactNoteContainerProps>()(() => ({
  teammate: makeGetTeammate(),
  team: makeGetTeam(),
}));

const mapDispatchToProps = makeMapDispatchToProps<ContactNoteContainerProps>()((props) => ({
  updateCardNoteAsync: (cardNote: CardNoteModel) =>
    updateCardNoteAsyncAction(props.note, cardNote, props.panelId),
  deleteCardNoteAsync: (cardNote: CardNoteModel) => deleteCardNoteAsyncAction(cardNote, props.panelId),
}));

export const ContactNoteContainer = connect(mapStateToProps, mapDispatchToProps)(ContactNote);
